export const entityKeys = {
  all: ["entities"],
  allEntities: () => [...entityKeys.all, "all"],
  entity: (entityId) => [...entityKeys.all, "single", entityId],
  entityRawData: (entityId) => [
    ...entityKeys.all,
    "single",
    entityId,
    "raw-data",
  ],
  entitiesRawData: (columns) => [...entityKeys.all, "raw-data", columns],
  entitiesByType: (type) => [...entityKeys.all, type],
  entitiesByTypePaginated: (type, pageSize) => [
    ...entityKeys.all,
    type,
    "paginated",
    pageSize,
  ],
  fields: (entityType) => [...entityKeys.all, "fields", entityType],
  fieldsForExport: (tenantIds = []) => [
    ...entityKeys.all,
    "fields-export",
    tenantIds,
  ],
  terminatedEntities: () => [...entityKeys.all, "terminated"],
  entitiesIdsByVulnerability: (vulnerabilityId) => [
    ...entityKeys.all,
    "vulnerability_entities_ids",
    vulnerabilityId,
  ],
  complexEntitiesByControl: (controlId) => [
    ...entityKeys.all,
    "control_complex_entities",
    controlId,
  ],
  entitiesByStep: (stepId) => [...entityKeys.all, "step_entities", stepId],
  entitiesByScenarioSet: (scenarioSetId) => [
    ...entityKeys.all,
    "scenarioSet_entities",
    scenarioSetId,
  ],
  allEntitiesByVulnerability: () => [
    ...entityKeys.all,
    "vulnerability_entities",
  ],
  entitiesByVulnerability: (vulnerabilityId) => [
    ...entityKeys.all,
    "vulnerability_entities",
    vulnerabilityId,
  ],
  entitiesByTechnique: (techniqueId) => [
    ...entityKeys.all,
    "technique_entities",
    techniqueId,
  ],
  entitiesByDetection: (detectionId) => [
    ...entityKeys.all,
    "detection_entities",
    detectionId,
  ],
  entitiesOverview: () => [...entityKeys.all, "overview"],
  vulnerabilitiesByEntityType: (entityType) => [
    ...entityKeys.all,
    "vulnerabilities",
    entityType,
  ],
  associationsByEntityType: (entityType) => [
    ...entityKeys.all,
    "associations",
    entityType,
  ],
  entityInstalledPrograms: (entityId) => [
    ...entityKeys.all,
    "installed-programs",
    entityId,
  ],
};

export const installedProgramKeys = {
  all: ["installed-programs"],
  filterOptions: () => [...installedProgramKeys.all, "filter-options"],
};

export const inventoryViewKeys = {
  all: ["inventory-views"],
  singleTenant: () => [...inventoryViewKeys.all, "single-tenant"],
};

export const controlKeys = {
  all: ["controls"],
  control: (controlId) => [...controlKeys.all, controlId],
  controlActivityLogs: (controlId) => [
    ...controlKeys.all,
    controlId,
    "activity-logs",
  ],
  batchControls: (controlIds) => [...controlKeys.all, controlIds],
  controlMisconfigurations: (controlId) => [
    ...controlKeys.all,
    controlId,
    "misconfigurations",
  ],
  controlMisconfiguredEntities: (controlId) => [
    ...controlKeys.all,
    controlId,
    "misconfigured-entities",
  ],
  controlMisconfigurationAffectedEntities: (controlId, misconfigurationId) => [
    ...controlKeys.all,
    controlId,
    "misconfigured-entities",
    misconfigurationId,
  ],
  isPlaybookAvailable: (controlId) => [
    ...controlKeys.all,
    "is-playbook-available",
    controlId,
  ],
  entityExcludedInControls: (entityId, controlIds) => [
    ...controlKeys.all,
    "entity-excluded-in-controls",
    entityId,
    controlIds,
  ],
};

export const assetKeys = {
  all: ["assets"],
  allAssets: () => [...assetKeys.all, "all"],
  smartAssets: () => [...assetKeys.all, "smart"],
  regularAssets: () => [...assetKeys.all, "regular"],
  asset: (assetId) => [...assetKeys.all, assetId],
  assetsBatch: (assetIds) => [...assetKeys.all, assetIds],
  assetCreationSuggestions: () => [...assetKeys.all, "creation-suggestions"],
  assetUpdateSuggestions: () => [...assetKeys.all, "update-suggestions"],
};

export const stepKeys = {
  all: ["steps"],
  step: (stepId) => [...stepKeys.all, stepId],
  batchSteps: (stepIds) => [...stepKeys.all, stepIds],
  stepsByScenarioSet: (scenarioId) => [...stepKeys.all, scenarioId],
  detectedSteps: () => [...stepKeys.all, "detected"],
};

export const scenarioSetKeys = {
  all: ["scenarioSets"],
};
export const scenarioKeys = {
  all: ["scenarios"],
  scenarioByScenarioSetId: (scenarioSetId) => [
    ...scenarioKeys.all,
    scenarioSetId,
  ],
  batchScenarios: (scenarioIds) => [...scenarioKeys.all, scenarioIds],
  scenariosByAsset: (assetId) => [...scenarioKeys.all, "asset", assetId],
  singleScenarioByScenarioSetId: (scenarioSetId) => [
    ...scenarioKeys.all,
    "single",
    scenarioSetId,
  ],
};

export const remediationKeys = {
  all: ["remediations"],
  remediation: (remediationId) => [...remediationKeys.all, remediationId],
  batchRemediations: (remediationIds) => [
    ...remediationKeys.all,
    remediationIds,
  ],
};

export const remediationAuditLogKeys = {
  all: ["remediation-audit-logs"],
  auditLogs: (controlId) => [...remediationAuditLogKeys.all, controlId],
};

export const vulnerabilityKeys = {
  all: ["vulnerabilities"],
  vulnerability: (vulnerabilityId) => [
    ...vulnerabilityKeys.all,
    vulnerabilityId,
  ],
  batchVulnerabilities: (vulnerabilityIds) => [
    ...vulnerabilityKeys.all,
    vulnerabilityIds,
  ],

  vulnerabilitiesByEntityId: (entityId) => [
    ...vulnerabilityKeys.all,
    "entities",
    entityId,
  ],
  crowdstrikeFirstCollectVulnerabilities: () => [
    ...vulnerabilityKeys.all,
    "crowdstrike-first-collect",
  ],
  fields: () => [...vulnerabilityKeys.all, "fields"],
};

export const widgetKeys = {
  all: ["widgets"],
  widgetType: (widgetId) => [...widgetKeys.all, widgetId],
};

export const attackTechniqueKeys = {
  all: ["attack-techniques"],
  attackTechnique: (attackTechniqueId) => [
    ...attackTechniqueKeys.all,
    attackTechniqueId,
  ],
  batchAttackTechniques: (attackTechniqueIds) => [
    ...attackTechniqueKeys.all,
    attackTechniqueIds,
  ],
};

export const slackKeys = {
  integrated: ["slack"],
  authUrl: () => [...slackKeys.integrated, "auth-url"],
};

export const slackSaasKeys = {
  integrated: ["slack-saas"],
  authUrl: () => [...slackSaasKeys.integrated, "auth-url"],
};

export const awsIntegratedKeys = {
  integrated: ["aws-integrated"],
  memberAccounts: () => [...awsIntegratedKeys.integrated, "member-account"],
  rootAccount: () => [...awsIntegratedKeys.integrated, "root-account"],
  cloudFormation: () => [...awsIntegratedKeys.integrated, "cloud-formation"],
  cloudFormationFolder: () => [
    ...awsIntegratedKeys.integrated,
    "cloud-formation-folder",
  ],
  rootExternalId: () => [...awsIntegratedKeys.integrated, "root-external-id"],
};

export const jiraKeys = {
  all: ["jira"],
  jiraProjects: () => [...jiraIssuesKeys.all, "projects"],
  jiraIssueTypes: (projectKey) => [
    ...jiraIssuesKeys.all,
    projectKey,
    "issue-types",
  ],
  jiraRequestTypes: (projectKey) => [
    ...jiraIssuesKeys.all,
    projectKey,
    "request-types",
  ],
  jiraCustomFields: (projectKey, issueTypeKey) => [
    ...jiraIssuesKeys.all,
    projectKey,
    issueTypeKey,
    "custom-fields",
  ],
  JSMRequestFields: (projectKey, requestTypeId) => [
    ...jiraIssuesKeys.all,
    projectKey,
    requestTypeId,
    "request-fields",
  ],
  jiraUsers: (projectKey) => [...jiraIssuesKeys.all, projectKey, "users"],
  jiraReporterOptions: () => [...jiraIssuesKeys.all, "reporter-options"],
  jsmIsAgent: () => [...jiraIssuesKeys.all, "jsm-is-agent"],
  jiraLabels: () => [...jiraIssuesKeys.all, "labels"],
};

export const jiraIssuesKeys = {
  all: ["jira-issues"],
  jiraIssueControl: (controlId) => [...jiraIssuesKeys.all, controlId],
  jiraIssueVulnerability: (vulnerabilityId) => [
    ...jiraIssuesKeys.all,
    "vulnerability",
    vulnerabilityId,
  ],
  allJiraIssueMisconfigurations: () => [
    ...jiraIssuesKeys.all,
    "misconfigurations",
  ],
  jiraIssueMisconfiguration: (misconfigId) => [
    ...jiraIssuesKeys.allJiraIssueMisconfigurations(),
    misconfigId,
  ],
  jiraMisconfigurationsWithTickets: (controlId) => [
    ...jiraIssuesKeys.all,
    "misconfigurations-with-tickets",
    controlId,
  ],
  jiraDefaultConfig: () => [...jiraIssuesKeys.all, "default-config"],
};

export const asanaKeys = {
  all: ["asana"],
  asanaProjects: () => [...asanaKeys.all, "projects"],
  asanaUsers: () => [...asanaKeys.all, "users"],
};

export const asanaTicketKeys = {
  all: ["asana-tickets"],
  asanaTicketControl: (controlId) => [...asanaTicketKeys.all, controlId],
};

export const ticketKeys = {
  // this is the key for the all tickets that are not per misconfiguration
  all: ["tickets"],
};

export const serviceNowKeys = {
  all: ["servicenow"],
  categories: ["servicenow-categories"],
  urgencies: ["servicenow-urgencies"],
};

export const serviceNowTicketKeys = {
  all: ["servicenow-tickets"],
  serviceNowTicketControl: (controlId) => [
    ...serviceNowTicketKeys.all,
    controlId,
  ],
};

export const serviceNowCMDBKeys = {
  all: ["servicenow_cmdb"],
  companies: () => [...serviceNowCMDBKeys.all, "companies"],
  configuration: () => [...serviceNowCMDBKeys.all, "configuration"],
};

export const platformUsersKeys = {
  all: ["all_platform_users"],
  user: () => [...platformUsersKeys.all, "user"],
  msspTenants: () => [...platformUsersKeys.all, "mssp-tenants"],
  favoriteControls: () => [...platformUsersKeys.all, "favorite-controls"],
  favoriteEntities: () => [...platformUsersKeys.all, "favorite-entities"],
};

export const notificationSettingsKeys = {
  all: ["notification-settings"],
};

export const scheduledEmailsKeys = {
  all: ["scheduled-emails"],
};

export const adminPermissionKeys = {
  all: ["adminUsers"],
};

export const issuesKeys = {
  all: ["issues"],
};
export const integrationKeys = {
  all: ["integrations"],
};

export const integrationsInfoKeys = {
  all: ["integrations-info"],
};

export const webhookConfigKeys = {
  all: ["webhookConfig"],
  webhookConfig: (toolName) => [...webhookConfigKeys.all, toolName],
};

export const integrationsMCPIDsKeys = {
  all: ["integrations-mcp-ids"],
};

export const ssoKeys = {
  all: ["sso"],
  isIntegrated: () => [...ssoKeys.all, "is-integrated"],
  oktaInitiateLoginURI: () => [...ssoKeys.all, "okta-initiate-login-uri"],
};

export const featureFlagsKeys = {
  env: ["env-feature-flags"],
  customer: ["customer-feature-flags"],
};

export const userAccessControlKeys = {
  all: ["action_to_role_mapping"],
};

export const detectionKeys = {
  all: ["detections"],
  detection: (detectionId) => [...detectionKeys.all, detectionId],
  detectionsByControl: (controlId) => [
    ...detectionKeys.all,
    "control",
    controlId,
  ],
  detectionByStep: (stepId) => [...detectionKeys.all, "step", stepId],
};

export const inAppNotificationKeys = {
  all: ["in-app-notifications"],
};

export const AzureKeys = {
  all: ["azure"],
  subscriptions: () => [...AzureKeys.all, "subscriptions"],
};

export const externalAPIKeys = {
  all: ["external-api"],
  backendURL: () => [...externalAPIKeys.all, "backend-url"],
  apiKeys: () => [...externalAPIKeys.all, "api-keys"],
  agentToken: () => [...externalAPIKeys.all, "agent-token"],
};

export const msspDashboardKeys = {
  all: ["mssp-dashboard"],
  stackUtilizationCoverage: () => [
    ...msspDashboardKeys.all,
    "stack-utilization-coverage",
  ],

  stackCoverageTable: (tool) => [
    ...msspDashboardKeys.all,
    "stack-coverage-table",
    tool,
  ],
  topIssues: () => [...msspDashboardKeys.all, "top-issues"],
  assetsBreakdown: () => [...msspDashboardKeys.all, "assets-breakdown"],
};

export const scanKeys = {
  all: ["scan"],
  isScanning: () => [...scanKeys.all, "is-scanning"],
  lastSuccessfulScan: () => [...scanKeys.all, "last-successful-scan"],
};

export const scheduledSlackMessagesKeys = {
  all: ["scheduled-slack-messages"],
};

export const scheduledEmailsDetailedKeys = {
  all: ["scheduled-emails-detailed"],
};

export const dashboardKeys = {
  all: ["dashboard"],
  widgetType: (widgetId) => [...dashboardKeys.all, widgetId],
  customWidgets: () => [...dashboardKeys.all, "custom-widgets"],
};

export const oktaKeys = {
  all: ["okta"],
  readScopes: () => [...oktaKeys.all, "read-scopes"],
  scopeCheck: () => [...oktaKeys.all, "scope-check"],
  manualScopeCheck: () => [...oktaKeys.all, "manual-scope-check"],
  manualMgmtScopeCheck: () => [...oktaKeys.all, "manual-mgmt-scope-check"],
  remediationPermissions: () => [...oktaKeys.all, "remediation-permissions"],
  managementScopes: () => [...oktaKeys.all, "management-scopes"],
};

export const addigyKeys = {
  all: ["addigy"],
  permissionCheck: () => [...addigyKeys.all, "permission-check"],
};

export const labelKeys = {
  all: ["labels"],
  labelsByEntity: (entityId) => [...labelKeys.all, "entity", entityId],
};

export const tagKeys = {
  all: ["tags"],
  tagsByEntity: (entityId) => [...tagKeys.all, "entity", entityId],
};

export const filterKeys = {
  all: ["filters"],
  savedFilters: (page) => [...filterKeys.all, "saved", page],
};

export const agentConnectorImagesKeys = {
  all: ["agent-connector-images"],
};

export const agentConnectorConfigsKeys = {
  all: ["agent-connector-configs"],
};

export const agentTokenKeys = {
  all: ["agent-token"],
};

export const onboardingKeys = {
  all: ["onboarding"],
};

export const scanHealthCheckKeys = {
  all: ["scan-health-check"],
};

export const auditLogsKeys = {
  all: ["audit-logs"],
  events: (userEmails = null, limit = null, date = null) => [
    ...auditLogsKeys.all,
    "events",
    userEmails,
    limit,
    date,
  ],
};

export const bootstrapKeys = {
  all: ["bootstrap"],
};

export const inventoryBootstrapKeys = {
  all: ["inventory-bootstrap"],
};

export const rdsEntitiesKeys = {
  all: ["rds-entities"],
  entity: (customerId, entityId) => [
    ...rdsEntitiesKeys.all,
    "entity",
    customerId || "",
    entityId || "",
  ],
};

export const aiDashboardKeys = {
  all: ["ai-dashboard"],
  widgetType: (widgetId) => [...aiDashboardKeys.all, widgetId],
};
